<mat-form-field appearance="outline" [formGroup]="formGroup">
  <input
    matInput
    [formControlName]="name"
    [matDatepicker]="picker"
    [placeholder]="placeholder ? (placeholder | locale) : ''"
    autocomplete="off"
    [min]="minimumDate"
    [max]="maximumDate || null"
    [matDatepickerFilter]="filter"
  />
  @if (displayIcon) {
    <mat-datepicker-toggle matSuffix [for]="picker">
      <mat-icon matDatepickerToggleIcon svgIcon="calendar-2"></mat-icon>
    </mat-datepicker-toggle>
  }
  <mat-datepicker #picker disabled="false" [touchUi]="isMobile" [calendarHeaderComponent]="customHeader" xPosition="end"></mat-datepicker>
</mat-form-field>
